module.exports = __webpack_public_path__ + "img/Topic-professional.2150c8aa.svg";